<template>
    <div class="user-list">
        <van-tabs class="tab" color="#1989fa" :line-width="70" :line-height="0" title-active-color="#1989fa" v-model="active" @click="getMyHandlingListInfo">
            <van-tab v-for="(item, index) in tabNameList" :key="index" :title="item.text"></van-tab>
        </van-tabs>
        <van-list class="list" v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" error-text="请求失败，点击重新加载" @load="loadMore">
            <van-cell v-for="(matterItem, matterIndex) in matterList" :key="matterIndex" is-link :to="'/myHandlingDetails/' + matterItem.tskNum">
                <template slot="title">
                    <p class="list-name">{{ matterItem.matName }}</p>
                    <p class="list-other">申报日期：{{ matterItem.startDoDateStr }}</p>
                    <p class="list-other">办件编号：{{ matterItem.tskNum }}</p>
                </template>
            </van-cell>
        </van-list>
    </div>
</template>

<script>
    /**
     * Description: 我的办件
     * Author: Wangyan
     * Date: 2019-03-07
     * Time: 09:57
     */

    import {Tab, Tabs, List, Cell} from 'vant'
    import { taskApiMap } from '@/api/task'

    export default {
        name: "MyHandlingList",
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [List.name]: List,
            [Cell.name]: Cell
        },
        data() {
            return {
                userGuid: this.$cookie.getUser().guid, // 用户Guid
                tabNameList: [ // tab标题
                    {text: '全部', type: ''},
                    {text: '办理中', type: "'2','3','1','4'"},
                    {text: '已办结', type: "'9'"},
                    {text: '已退回', type: "'13'"},
                    // {text: '已撤销', type: "'-1'"}
                ],
                active: 0, // 控制tab选择
                tabNameListIndex: 0, // 存放tab下标
                page: 0, // 每次加载条目数
                matterList: [], // 存放我的办件列表
                loading: false, // 是否显示加载loading图标
                finished: false, // 控制"没有更多了"的显示与隐藏
                error: false, // 控制访问接口异常情况下，可以再次重新访问接口
            }
        },
        deactivated() { // 缓存结束钩子，控制进入详情页面页面保持缓存，其他初始化。
            if (this.$route.name !== 'MyHandlingDetails') {
                this.active = 0
                this.getMyHandlingListInfo(this.active)
            }
        },
        methods: {
            /**
             * 异步方法，获取办件列表信息
             * @param index 点击tab切换传来的下标
             */
            async getMyHandlingListInfo(index) {
                if (this.tabNameListIndex !== index) {
                    this.page = 10
                }
                this.tabNameListIndex = index
                try {
                    const data = {
                        ps: this.page,
                        pi: 1,
                        sb: 'creatordate',
                        sd: 'desc',
                        deleted: 'N',
                        projectstatus: this.tabNameList[index].type,
                    }
                    const res = await this.$httpUtils.getGatewayUtils(taskApiMap.getTaskPage, data)
                    this.matterList = res.data.data.list
                    this.loading = false
                    if (this.page >= res.data.data.totalRow) {
                        this.finished = true
                    } else {
                        this.finished = false
                    }
                } catch (error) {
                    this.error = true
                    this.loading = false
                    console.log(error)
                }

            },
            /**
             * 上拉加载
             */
            loadMore() {
                this.page += 10
                this.getMyHandlingListInfo(this.tabNameListIndex)
            },
        },
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/user/UserList.less";
</style>
